const FALLBACK_SITE_ORIGIN = 'https://www.dopomogai.com';

export const normalizeSiteOrigin = (value?: string | null) => {
  if (!value) return FALLBACK_SITE_ORIGIN;
  return value.replace(/\/+$/, '');
};

export const getSiteOrigin = () => {
  if (typeof window !== 'undefined' && window.location?.origin) {
    return normalizeSiteOrigin(window.location.origin);
  }

  return normalizeSiteOrigin(import.meta.env.VITE_PUBLIC_SITE_URL);
};

export const getSiteUrl = (path = '/') => {
  const normalizedPath = path.startsWith('/') ? path : `/${path}`;
  return `${getSiteOrigin()}${normalizedPath}`;
};

export const isServiceRoleSupabaseKey = (value?: string | null) => {
  if (!value) return false;

  const [, payload] = value.split('.');
  if (!payload) return false;

  try {
    const decoded = JSON.parse(atob(payload.replace(/-/g, '+').replace(/_/g, '/')));
    return decoded?.role === 'service_role';
  } catch {
    return false;
  }
};

export const getPublicConfigError = (supabaseUrl?: string, supabaseAnonKey?: string, apiUrl?: string) => {
  const missing = [
    !supabaseUrl && 'VITE_SUPABASE_URL',
    !supabaseAnonKey && 'VITE_SUPABASE_ANON_KEY',
    !apiUrl && 'VITE_API_URL',
  ].filter(Boolean) as string[];

  if (missing.length > 0) {
    return `Missing environment variables: ${missing.join(', ')}.`;
  }

  if (isServiceRoleSupabaseKey(supabaseAnonKey)) {
    return 'VITE_SUPABASE_ANON_KEY is using a Supabase service_role token. Replace it with the public anon key before running the website.';
  }

  return null;
};
